import SoftTypography from "components/SoftTypography";
import moment from "moment";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";



function getText(epoch){
    if(epoch){
        return "Last updated " + moment.duration((moment().unix() * 1000) - epoch).humanize({ ss: 3 }) + " ago - " + moment(epoch).format("HH:mm:ss");
    }
    else{
        return "Loading..."
    }
}
function FromNow({ epoch }) {

    const [count, updateCount] = useState(0);

    useEffect(() => {
        setInterval(function () {
            updateCount((c) => c + 1);
        }, 1000);
    }, []);


    return (<SoftTypography variant="h6" >
        {getText(epoch)}
    </SoftTypography>);
}

FromNow.propTypes = {
    epoch: PropTypes.number
}

export default FromNow;